import React from 'react'

import type { StarType } from '@/types/components/buying-panel/rating-star'
import type { RatingStarsProps } from '@/types/components/buying-panel/rating-stars'

import RatingStar from './RatingStar'

import './RatingStars.scss'

const convertRatingToArr = (rating: number): StarType[] => {
  const roundedStars = (Math.round(rating * 2) / 2).toFixed(1)
  const splitFloat = `${roundedStars}`.split('.')
  const fullStars = splitFloat[0]
  const halfStars = splitFloat[1]
  let starsArray: StarType[] = []

  for (let index = 0; index < parseInt(fullStars); index++) {
    starsArray.push('full')
  }

  if (parseInt(halfStars)) starsArray.push('half')

  if (starsArray.length < 5) {
    const emptyStars = 5 - starsArray.length
    for (let index = 0; index < emptyStars; index++) {
      starsArray.push('empty')
    }
  }

  return starsArray as StarType[]
}

const RatingStars: React.FC<RatingStarsProps> = ({ rating, count }) => {
  const stars: StarType[] = convertRatingToArr(rating)

  return (
    <div className="buying-panel-rating-stars">
      {stars.map((starType, index) => (
        <RatingStar key={index} type={starType} />
      ))}
      {count !== undefined && (
        <a href="#product-reviews" className="type-label underline-on-hover">
          ({count})
        </a>
      )}
    </div>
  )
}

export default RatingStars
